import { z } from 'zod';

export const CreateMenuSectionEntrySchema = z.object({
    type: z.string(),
    dialog: z.boolean(),
    favorite: z.boolean(),
    url: z.string().optional(),
});

export const CreateMenuSectionSchema = z.object({
    label: z.string(),
    entries: z.array(CreateMenuSectionEntrySchema),
});

export const CreateMenuSectionsSchema = z.array(CreateMenuSectionSchema);
export type CreateMenuSections = z.infer<typeof CreateMenuSectionsSchema>;
